import { render } from "./SuperAdminOrgTableItemExpandSection.vue?vue&type=template&id=009c6ef6&scoped=true"
import script from "./SuperAdminOrgTableItemExpandSection.vue?vue&type=script&lang=js"
export * from "./SuperAdminOrgTableItemExpandSection.vue?vue&type=script&lang=js"

import "./SuperAdminOrgTableItemExpandSection.vue?vue&type=style&index=0&id=009c6ef6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009c6ef6"]])

export default __exports__